var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterUsdAscIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3869_85044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10.0824C0.142445 11.6303 1.45621 12.7288 3.45621 12.8709V14H4.46006V12.8709C6.64485 12.7046 8 11.5356 8 9.80657C8 8.33014 7.08855 7.47586 5.15496 6.99486L4.46006 6.82121V3.29079C5.53994 3.39293 6.26853 3.95379 6.45236 4.79136H7.86718C7.70741 3.30564 6.38498 2.23964 4.46006 2.12171V1H3.45621V2.14493C1.58999 2.3585 0.308951 3.51179 0.308951 5.0755C0.308951 6.42564 1.23869 7.38114 2.87007 7.78414L3.45717 7.93457V11.6776C2.3513 11.5198 1.58999 10.9348 1.40616 10.0824H0ZM3.26371 6.52036C2.25987 6.27614 1.72377 5.75429 1.72377 5.01979C1.72377 4.14321 2.40135 3.496 3.45621 3.32236V6.56771L3.26371 6.52129V6.52036ZM4.795 8.25864C6.03369 8.55857 6.57748 9.05629 6.57748 9.90129C6.57748 10.9199 5.78248 11.5987 4.46006 11.7018V8.17786L4.795 8.25771V8.25864Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4997 13.2507C12.5992 13.2507 12.6946 13.2112 12.7649 13.1408C12.8352 13.0705 12.8747 12.9751 12.8747 12.8757V4.03092L15.2342 6.39117C15.3047 6.46159 15.4002 6.50114 15.4997 6.50114C15.5993 6.50114 15.6948 6.46159 15.7652 6.39117C15.8357 6.32076 15.8752 6.22525 15.8752 6.12567C15.8752 6.02609 15.8357 5.93059 15.7652 5.86017L12.7652 2.86017C12.7304 2.82525 12.689 2.79754 12.6435 2.77864C12.5979 2.75973 12.5491 2.75 12.4997 2.75C12.4504 2.75 12.4016 2.75973 12.356 2.77864C12.3105 2.79754 12.2691 2.82525 12.2342 2.86017L9.23424 5.86017C9.19938 5.89504 9.17172 5.93643 9.15285 5.98198C9.13398 6.02754 9.12427 6.07636 9.12427 6.12567C9.12427 6.22525 9.16383 6.32076 9.23424 6.39117C9.30466 6.46159 9.40016 6.50114 9.49974 6.50114C9.59932 6.50114 9.69483 6.46159 9.76524 6.39117L12.1247 4.03092V12.8757C12.1247 12.9751 12.1643 13.0705 12.2346 13.1408C12.3049 13.2112 12.4003 13.2507 12.4997 13.2507Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3869_85044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterUsdAscIcon);
export default __webpack_public_path__ + "static/media/filter-usd-asc-icon.bc4ef3e4aac77a7c5bade754e9371797.svg";
export { ForwardRef as ReactComponent };